module.exports = __webpack_public_path__ + "static/img/supplier4.3273168.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/supplier4.png
// module id = c77p
// module chunks = 192